// 2026 Vege Fest entry time slots.
//
// Last year everyone arrived at once, so entry is split into three windows and
// each guest picks one when registering. Kept in sync with
// server-side/app/config/vege_fest_2026.py by tests/test_vegefest_2026.py.
//
// The stored value is the literal time range, so exports and reports stay
// readable without a lookup table.

export const VEGE_FEST_SLOTS = [
  { value: "11:30-12:30", start: "11:30", end: "12:30" },
  { value: "12:30-13:30", start: "12:30", end: "13:30" },
  { value: "13:30-14:30", start: "13:30", end: "14:30" },
];

// A time range reads the same in both languages; only the wrapper text differs.
export const getSlotLabel = (slot) => `${slot.start} - ${slot.end}`;

export const findSlot = (value) =>
  VEGE_FEST_SLOTS.find((slot) => slot.value === value) || null;

// Which slot a given "HH:MM" falls in, for warning at check-in. Null outside them.
export const slotForTime = (hhmm) =>
  VEGE_FEST_SLOTS.find((slot) => hhmm >= slot.start && hhmm < slot.end) || null;
